const selectColor: {
  color: string;
  buttonColor: string;
}[] = [
  {
    color: "#272643",
    buttonColor: "#2C698D",
  },
  {
    color: "#751A0A",
    buttonColor: "#753C0A",
  },
  {
    color: "#004585",
    buttonColor: "#5D0032",
  },
  {
    color: "#E48958",
    buttonColor: "#000000",
  },
  {
    color: "#579A4C",
    buttonColor: "#084200",
  },
  {
    color: "#501466",
    buttonColor: "#260E47",
  },
];

export default selectColor;
